import axios from "axios";
import { logger } from "../logger/index";
const reqAuth = (url = `/login/`, option = {}) => {
  return new Promise(async (reso, rej) => {
    try {
      reso(
        await axios({
          url: process.env.NEXT_PUBLIC_API + url,
          method: "GET",
          ...option,
          headers: {
            ...option.headers,
            authorization: "Bearer " + sessionStorage.getItem("token"),
          },
        })
      );
    } catch (err) {
      if (err.message == "Request failed with status code 401") {
        if (!sessionStorage.getItem("token"))
          logger.error("AUTH ERROR", "Not Connected");
        sessionStorage.removeItem("token");
      }
      logger.error("AUTH ERROR", err.message);
      rej(err);
    }
  });
};

export default reqAuth;
